import { ModalStateProps, useModalState } from "@/components/misc/Modal";

export const useDrawerState = (data: ModalStateProps = {}) =>
  useModalState(data);
